import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import type { ProjectDashboardRevision } from '../projectDashboardTypes';

const defaultRevisionValue: ProjectDashboardRevision = {
  data: undefined,
  status: {
    loading: false,
    error: undefined,
  },
  isSteady: false,
};

export const RevisionContext = createContext<ProjectDashboardRevision>(defaultRevisionValue);

export const useRevision = () => useContext(RevisionContext);

type RevisionProviderProps = {
  children: ReactNode;
  value: ProjectDashboardRevision;
};

export const RevisionProvider = ({ children, value }: RevisionProviderProps) => (
  <RevisionContext.Provider value={value}>
    {children}
  </RevisionContext.Provider>
);

export default RevisionProvider;
